import React from 'react';

const Trainingplatform = () => {
  const features = [
    {
      icon: '💻',
      title: 'On-Job IT Training',
      description: 'Industry-aligned IT training programs with hands-on experience and real-world projects',
    },
    {
      icon: '👶',
      title: 'Kids Programming',
      description: 'Age-appropriate coding curriculum for children from basic concepts to advanced programming',
    },
    {
      icon: '👨‍🏫',
      title: 'Industry Mentors',
      description: 'Access to experienced professionals and industry experts as mentors for students',
    },
    {
      icon: '🤖',
      title: 'Robotics Lab',
      description: 'State-of-the-art robotics laboratory with modern equipment and project-based learning',
    },
    {
      icon: '🎓',
      title: 'Certification Programs',
      description: 'Industry-recognized certifications in various IT and technology domains',
    },
    {
      icon: '📊',
      title: 'Progress Analytics',
      description: 'Advanced tracking system to monitor student progress and skill development',
    },
  ];

  return (
    <div className="trainingplatform-container container-fluid text-center">
      <h2 className="fw-bold mb-3">Why Choose Our Training Platform?</h2>
      <p className="lead mb-5">
        Register your institution to access comprehensive IT training programs, kids coding <br />
        courses, industry mentorship, and cutting-edge robotics facilities
      </p>
<div className='container col-12'>

   <div className="trainingplatform-row  row">
        {features.map((feature, index) => (
          <div key={index} className="trainingplatform-col col-md-4 mb-4">
            <div className="trainingplatform-card p-4 rounded shadow-sm">
              <div className="trainingplatform-icon" style={{ fontSize: '36px' }}>
                {feature.icon}
              </div>
              <h5 className="trainingplatform-title fw-bold mt-3">{feature.title}</h5>
              <p className="trainingplatform-desc">{feature.description}</p>
            </div>
          </div>
        ))}
      </div>
</div>
     
    </div>
  );
};

export default Trainingplatform;
